import { BaseClient } from './baseClient';

/** RFQ hit from `GET /trp/search` — display name + human id. */
export interface SearchRfqHit {
    rfqId: string;
    name: string;
    status: string;
    updatedAt: string;
}

/** Supplier candidate hit, deduped by name org-wide; carries its RFQ context. */
export interface SearchSupplierHit {
    name: string;
    status: string | null;
    rfqId: string;
    rfqName: string;
    componentId: string;
    componentName: string;
}

/** BOM part hit (component name / part id / manufacturer match). */
export interface SearchPartHit {
    componentId: string;
    name: string;
    manufacturer: string | null;
    rfqId: string;
    rfqName: string;
}

/**
 * Org-scoped global search result. `truncated.<group>` means more matches
 * exist server-side than the per-group cap returned.
 */
export interface GlobalSearchData {
    query: string;
    limitPerGroup: number;
    rfqs: SearchRfqHit[];
    suppliers: SearchSupplierHit[];
    parts: SearchPartHit[];
    truncated: { rfqs: boolean; suppliers: boolean; parts: boolean };
}

interface GlobalSearchResponse {
    success: boolean;
    data: GlobalSearchData;
}

class SearchClient extends BaseClient {
    /** `q` must be ≥2 chars (server rejects shorter); the hook enforces it too. */
    async search(q: string, signal?: AbortSignal): Promise<GlobalSearchData> {
        const response = await this.api.get<GlobalSearchResponse>('/trp/search', {
            params: { q },
            signal,
        });
        return response.data.data;
    }
}

export const searchClient = new SearchClient();
